import { render, staticRenderFns } from "./hycot201.vue?vue&type=template&id=b5c54a56&scoped=true"
import script from "./hycot201.vue?vue&type=script&lang=js"
export * from "./hycot201.vue?vue&type=script&lang=js"
import style0 from "./hycot201.vue?vue&type=style&index=0&id=b5c54a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c54a56",
  null
  
)

export default component.exports